import React from 'react';
import PropTypes from 'prop-types';
import { PulseLoader } from 'react-spinners';
import { css } from 'react-emotion';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Loading extends React.Component {
  render() {
    return (
      <div className="loading" style={{ textAlign: 'center', minHeight: '140px', padding: '60px' }}>
        <PulseLoader className={override} color={'#123abc'} loading={this.props.show} />
      </div>
    );
  }
}
Loading.propTypes = {
  show: PropTypes.bool,
};

export default Loading;
